<div class="container mb-5">
  <div class="row">
    <div class="col-lg-4 order-lg-12">
      <div class="row">
        <div class="col text-center">
          <h3>Delivery Fee</h3>
        </div>
      </div>

      <div class="row no-gutters">
        <div class="col euro2 text-center rounded-lg p-2">
          <p class="font-weight-bold">2.00€</p>
          <p>Kesklinn</p>
          <p>Põhja-Tallinn</p>
          <p>Kristiine</p>
        </div>
        <div class="col euro3 text-center rounded-lg p-2">
          <p class="font-weight-bold">3.00€</p>
          <p>Haabersti</p>
          <p>Lasnamäe</p>
          <p>Mustamäe</p>
        </div>
        <div class="col euro4 text-center rounded-lg p-2">
          <p class="font-weight-bold">4.00€</p>
          <p>Nõmme</p>
          <p>Pirita</p>
          <p>Past Ülemiste</p>
        </div>
      </div>
    </div>

    <div class="col-lg-8 order-lg-1">
      <img src="/assets/img/TallinnMap.png" class="card-img" alt="Map of Tallinn Delivery area" />
    </div>
  </div>
</div>
